import { Resources } from 'constants/resources';

import { bulkAddProviderAccountsMembers } from 'config/requests/providerAccounts';
import { ProviderAccountsWorkTeamSelect } from 'pages/Finance/ProviderAccounts/components/ProviderAccountsWorkTeamSelect/ProviderAccountsWorkTeamSelect';
import { queryClient } from 'providers/queryClient';
import { SimpleForm, useNotify, useUnselectAll } from 'react-admin';
import { FieldValues, SubmitHandler } from 'react-hook-form';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { AutocompleteMultiselectInput } from 'shared/react-admin/Inputs';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { WorkTeamMember } from 'types/embedded/workTeam';

import { StyledDialog } from './WorkTeamUsersBulkAddDialog.styled';

type WorkTeamUsersBulkAddDialogProps = {
  providerAccounts: ProviderAccount[];
  onClose: () => void;
} & DialogProps;

const validateMembers = (value: string[]) => (value?.length ? undefined : 'Обязательное поле');

export const WorkTeamUsersBulkAddDialog = ({
  open,
  providerAccounts,
  onClose,
}: WorkTeamUsersBulkAddDialogProps) => {
  const notify = useNotify();
  const unselectAll = useUnselectAll(Resources.ProviderAccounts);

  const workTeam = providerAccounts[0]?.workTeam;

  const handleSubmit: SubmitHandler<FieldValues> = async (data) => {
    try {
      await bulkAddProviderAccountsMembers({
        providerAccounts: providerAccounts.map((providerAccount) => providerAccount['@id']),
        members: data.members,
      });
      await queryClient.refetchQueries({ queryKey: [Resources.ProviderAccounts] });
      notify('В настройки доступа успешно добавлены новые ответственные');
      unselectAll();
      onClose();
    } catch (error: any) {
      notify(error?.data?.errors?.[0]?.title || error?.data?.detail, { type: 'error' });
    }
  };

  return (
    <StyledDialog onClose={onClose} open={open} width="640px">
      <SimpleForm mode="all" onSubmit={handleSubmit} toolbar={<></>}>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title="Добавление ответственных"
          titleSize="smallBold"
        />
        <CardContent sx={{ width: '100%' }}>
          <ProviderAccountsWorkTeamSelect workTeam={workTeam} />

          <AutocompleteMultiselectInput
            fullWidth
            getOptionLabel={(record: WorkTeamMember) => `${record?.firstName} ${record?.lastName}`}
            helperText={false}
            label="Сотрудники"
            name="members"
            optionValue="@id"
            options={workTeam?.members || []}
            size="small"
            source="members"
            validate={validateMembers}
          />
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" onClick={onClose} variant="outlined" />,
            <SaveButtonValidated key="save-button" label="Сохранить" />,
          ]}
        />
      </SimpleForm>
    </StyledDialog>
  );
};
